<template>
    <div style="border: 1px solid #ccc">
        <Toolbar v-show="!editorConfig.readOnly" style="border-bottom: 1px solid #ccc" :editor="editorRef" :defaultConfig="toolbarConfig" :mode="mode" />
        <Editor style="overflow-y: hidden;" v-model="valueHtml" :defaultConfig="editorConfigComputed"
            :mode="mode" @onCreated="handleCreated" @onChange="handleChange" />
    </div>
</template>

<script>
import '@wangeditor/editor/dist/css/style.css' // 引入 css
import { onBeforeUnmount, ref, shallowRef, onMounted, watch, computed } from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { getToken } from '@/utils/auth'
export default {
    name: "gljy-rich-text",
    components: { Editor, Toolbar },
    emits: ["update:value"],
    props: {
        value: {
            type: String,
        },
        // readOnly: true 只读
        editorConfig: {
            type: Object,
            default: () => {
                return {
                    placeholder: '请输入内容...'
                }
            }
        },
        mode: { // 'default', // 或 'simple'
            type: String,
            default: "default"
        }
    },
    setup(props, context) {
        // 编辑器实例，必须用 shallowRef
        const editorRef = shallowRef()
        // 内容 HTML
        const valueHtml = ref('')

        watch(() => props.value, () => {
            valueHtml.value = props.value ? props.value : '';
        })

        const toolbarConfig = {};



        const editorConfigComputed = computed(() => {
            const config = {
                MENU_CONF: {
                    uploadImage: {
                        server: import.meta.env.VITE_APP_BASE_API + "/file/upload",
                        // form-data fieldName ，默认值 'wangeditor-uploaded-image'
                        fieldName: 'file',
                        // 单个文件的最大体积限制，默认为 2M
                        maxFileSize: 5 * 1024 * 1024, // 5M
                        // 最多可上传几个文件，默认为 100
                        maxNumberOfFiles: 10,
                        // 选择文件时的类型限制，默认为 ['image/*'] 。如不想限制，则设置为 []
                        allowedFileTypes: ['image/*'],
                        // 自定义上传参数，例如传递验证的 token 等。参数会被添加到 formData 中，一起上传到服务端。
                        meta: {
                        },
                        // 将 meta 拼接到 url 参数中，默认 false
                        metaWithUrl: false,
                        // 自定义增加 http  header
                        headers: {
                            Authorization: 'Bearer ' + getToken(),
                        },
                        // 跨域是否传递 cookie ，默认为 false
                        withCredentials: true,
                        // 超时时间，默认为 10 秒
                        timeout: 20 * 1000, // 5 秒
                        // 上传之前触发
                        onBeforeUpload(file) {
                            // file 选中的文件，格式如 { key: file }
                            return file
                            // 可以 return
                            // 1. return file 或者 new 一个 file ，接下来将上传
                            // 2. return false ，不上传这个 file
                        },
                        // 上传进度的回调函数
                        onProgress(progress) {
                            console.log('progress', progress)
                        },
                        // 单个文件上传成功之后
                        onSuccess(file, res) {
                            console.log(`${file.name} 上传成功`, res)
                        },
                        // 单个文件上传失败
                        onFailed(file, res) {
                            console.log(`${file.name} 上传失败`, res)
                        },
                        // 上传错误，或者触发 timeout 超时
                        onError(file, err, res) {
                            console.log(`${file.name} 上传出错`, err, res)
                        },
                        // 自定义插入图片
                        customInsert(res, insertFn) {
                            // customInsert(res, insertFn) {                  // JS 语法
                            // res 即服务端的返回结果
                            // 从 res 中找到 url alt href ，然后插入图片
                            if (res?.code == 200) {
                                insertFn(res.data.url, res.data.name, undefined)
                            }
                        },
                    }
                }
            }
            Object.keys(props.editorConfig).forEach(key => {
                config[key] = props.editorConfig[key];
            })
            return config;
        })

        // 组件销毁时，也及时销毁编辑器
        onBeforeUnmount(() => {
            const editor = editorRef.value
            if (editor == null) return
            editor.destroy()
        })

        const handleCreated = (editor) => {
            editorRef.value = editor // 记录 editor 实例，重要！
        }

        const methods = {
            handleChange(editor) {
                // console.log('change:', editor.children, valueHtml.value)
                context.emit("update:value", valueHtml.value);
            }
        }

        return {
            editorRef,
            valueHtml,
            toolbarConfig,
            editorConfigComputed,
            handleCreated,
            ...methods
        }
    },
}
</script>

<style></style>